/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const OutgoingCallIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    onClick={props.onClick}
  >
    <g strokeWidth="2.5">
      <path d="M29.968 40.048a8.006 8.006 0 0 0 0-11.312l-8.488-8.488c-3.12-3.124-8.192-3.124-11.316 0l-4.652 4.656C1.472 28.94.852 35.24 4 40.004c13.52 20.44 31.556 38.476 52 52 4.752 3.14 11.072 2.512 15.092-1.516l4.656-4.656c3.124-3.12 3.124-8.188 0-11.312l-8.484-8.484c-3.124-3.124-8.192-3.124-11.312 0l-2.828 2.828C43.82 61.24 34.76 52.18 27.14 42.876l2.828-2.828zM94 2.004l-40 40M68 2h26v26" />
    </g>
  </svg>
);

export default OutgoingCallIcon;
